import { createFileRoute } from '@tanstack/react-router';
import { RedditResearchPage } from '../../../pages/tools/research-tools/RedditResearchPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/reddit-research')({
  head: () => toolHead('reddit-research'),
  component: RedditResearchPage,
});
